export class WorkFlowAddCcRequest {
  token?: string;
  workFlowId?: number;
  sectionId?: number;
  organizationId?: number;
  departmentId?: number;
  postId?: number;
  userId?: number;
}
